var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgMeeting(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 13,
    viewBox: "0 0 13 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_9242_200964)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.96094 9.34375C5.02667 9.34375 5.89062 8.4798 5.89062 7.41406C5.89062 6.34833 5.02667 5.48438 3.96094 5.48438C2.8952 5.48438 2.03125 6.34833 2.03125 7.41406C2.03125 8.4798 2.8952 9.34375 3.96094 9.34375Z",
    stroke: "#667085",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.21875 12.3906C1.21875 11.5825 1.53976 10.8076 2.11116 10.2362C2.68256 9.66476 3.45754 9.34375 4.26562 9.34375M7.10938 12.3906C7.10938 11.9905 7.03057 11.5943 6.87745 11.2246C6.72433 10.855 6.49989 10.5191 6.21697 10.2362C5.93404 9.95323 5.59815 9.7288 5.22849 9.57568C4.85882 9.42256 4.46262 9.34375 4.0625 9.34375",
    stroke: "#667085",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.63281 4.46875C9.69855 4.46875 10.5625 3.6048 10.5625 2.53906C10.5625 1.47333 9.69855 0.609375 8.63281 0.609375C7.56708 0.609375 6.70312 1.47333 6.70312 2.53906C6.70312 3.6048 7.56708 4.46875 8.63281 4.46875Z",
    stroke: "#667085",
    strokeMiterlimit: 10
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.89062 7.3125C5.89062 5.74031 7.25359 4.46875 8.9375 4.46875M11.7812 7.3125C11.7812 5.74031 10.4183 4.46875 8.73438 4.46875",
    stroke: "#667085",
    strokeMiterlimit: 10
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_9242_200964"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 13,
    height: 13,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgMeeting);
export default __webpack_public_path__ + "static/media/meeting.c64ace739ea03aa23386ad9996761caf.svg";
export { ForwardRef as ReactComponent };